import React, { useEffect, useState } from 'react';
import { Button, Result } from 'antd';
import './orderConfPage.css';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const OrderConfirmationPage = ({ paymentStatus}) => {


    console.log('paymentStatus',paymentStatus);
    
    const history = useHistory()
    const [data, setData] = useState([]);

    useEffect(()=>{
        setData(paymentStatus?.invoiceInfo?.courseDetails)
        // Push data to dataLayer
            const courseNames = paymentStatus?.invoiceInfo?.courseDetails
            .map(course => course?.name)
            .join(", ");
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "purchase_successful",
            transactionID: paymentStatus?.invoiceInfo?.orderNo,
            studentName: paymentStatus?.invoiceInfo?.studentName,
            studentEmail: paymentStatus?.invoiceInfo?.studentEmail || "-",
            studentPhone: paymentStatus?.invoiceInfo?.studentPhone,
            totalAmount: paymentStatus?.invoiceInfo?.totalAmount,
            courses: courseNames 
        });

        console.log("Data pushed to dataLayer:", window.dataLayer);
    },[paymentStatus])

    return (
        <div className="order-confirmation-wrapper scroll-bar-universal">
            <Result
                status="success"
                title="Successfully Purchased"
                subTitle={`Transaction ID : ${paymentStatus?.invoiceInfo?.orderNo}`}
            // extra={[

            // ]}
            />

            <div className="order-confirmation-container" style={{ padding: '0px 100px' }}>
                <h2 className='order-conf-h2'>Order Summary</h2>
                <div className="table-container-order">
                    <table className="data-table-order">
                        <colgroup>
                            <col className="col-sl" />
                            <col className="col-name" />
                            <col className="col-email" />
                            <col className="col-phone" />
                            <col className="col-course" />
                            <col className="col-payment" />
                            <col className="col-transaction" />
                        </colgroup>
                        <thead className="table-header-order">
                            <tr>
                                <th className="table-header-cell">SL No</th>
                                <th className="table-header-cell">Name</th>
                                <th className="table-header-cell">Email</th>
                                <th className="table-header-cell">Phone Number</th>
                                <th className="table-header-cell">Course Name</th>
                                <th className="table-header-cell">Payment</th>
                                <th className="table-header-cell">Transaction ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((row,index) => (
                                <tr key={row.id} className="table-row">
                                    <td className="table-data-cell">{index+1}</td>
                                    <td className="table-data-cell">{paymentStatus?.invoiceInfo?.studentName}</td>
                                    <td className="table-data-cell">{paymentStatus?.invoiceInfo?.studentEmail ? paymentStatus?.invoiceInfo?.studentEmail : '-'}</td>
                                    <td className="table-data-cell">{paymentStatus?.invoiceInfo?.studentPhone}</td>
                                    <td className="table-data-cell course-column-order" title={row.name}>{row.name}</td>
                                    <td className="table-data-cell">{`₹ ${row?.totalAmount}`}</td>
                                    <td className="table-data-cell">{paymentStatus?.invoiceInfo?.orderNo}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div style={{marginTop:50, display:'flex' , justifyContent:'center'}}>
                <Button type="primary" key="console" onClick={()=>{history.push("/")}}>
                    Go Back
                </Button>,
            
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const { userMarketPlaceHomeData, paymentStatus } = state.studentMarketPlace;
    return { userMarketPlaceHomeData , paymentStatus};
};

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmationPage);